import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/index';
import { ContactPage } from './pages/ContactPage';
import { useTheme } from './hooks/useTheme';
import { CursorGrid } from './components/CursorGrid';

function App() {
  const { isDark } = useTheme();

  return (
    <Router>
      <div className={isDark ? 'dark' : ''}>
        <CursorGrid />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
